import { useEffect, useState } from "react";
import api from "@/lib/api";

const Side = ({ label, html, testid, scale }) => (
  <div>
    <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</div>
    <div className="relative w-full overflow-hidden rounded-md border border-slate-200 shadow-sm" style={{ aspectRatio: "6 / 4" }}>
      <iframe title={label} srcDoc={html} data-testid={testid} scrolling="no" className="absolute left-0 top-0 border-0"
        style={{ width: 576, height: 384, transform: `scale(${scale})`, transformOrigin: "0 0" }} />
    </div>
  </div>
);

export const PostcardPreview = ({ draft }) => {
  const [p, setP] = useState(null);
  const [scale, setScale] = useState(0.5);
  useEffect(() => {
    const t = setTimeout(() => { api.post("/surety/outreach/preview", draft).then((r) => setP(r.data)).catch(() => {}); }, 400);
    return () => { clearTimeout(t); };
  }, [draft]);
  const ref = (el) => { if (el) { const s = el.clientWidth / 576; if (Math.abs(s - scale) > 0.01) setScale(s); } };
  if (!p) return null;
  return (
    <div className="mt-2 grid grid-cols-1 gap-4 md:grid-cols-2" data-testid="postcard-preview">
      <div ref={ref}><Side label="Front" html={p.front} testid="postcard-preview-front" scale={scale} /></div>
      <div><Side label="Back (sample contractor)" html={p.back} testid="postcard-preview-back" scale={scale} /></div>
    </div>
  );
};
